import {Divider} from "@mui/material";
import IDiagramApi from "../../../../../common/diagrameditor/api/IDiagramApi";
import React from "react";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import IDiagramEditorApi from "../../../../../common/diagrameditor/api/IDiagramEditorApi";
import {AlignmentType} from "../../../../../common/diagrameditor/common/AlignmentType";
import {IDiagramConnectionDto} from "../../../../../common/apis/diagram/IDiagramConnectionDto";
import AlignNodesMenuItems from "./AlignNodesMenuItems";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ContextMenu} from "../../../../../diagram/editor/components/menu/ContextMenu";
import {DiagramEditorTranslationKey} from "./DiagramEditorTranslationKey";
import {Brush, Delete, Description} from "@mui/icons-material";
import {MenuItem} from "../../../../../components/menu/MenuItem";
import {IDiagramNodeDto} from "../../../../../common/apis/diagram/IDiagramNodeDto";
import {EventType, OnDeleteSelectedItemsMenuActivatedEvent} from "../../../../../common/event/Event";
import EventManager from "../../../../../common/event/EventManager";

interface Props {
    opened: boolean,
    selectedNodes: IDiagramNodeDto[],
    selectedConnections: IDiagramConnectionDto[],
    clientCoordinates: [number, number],
    onClose: () => void,
    onStylesClick: () => void,
    diagramApi: IDiagramApi,
    diagramEditorApi?: IDiagramEditorApi,
    eventManager?: EventManager,
}

export default function ConnectionContextMenu(props: Readonly<Props>) {

    const {
        opened, onClose, selectedConnections,
        clientCoordinates, diagramApi, diagramEditorApi, eventManager
    } = props;
    const isAlignDisabled = !diagramEditorApi?.areSelectedNodesAlignable();
    const anchorPosition = {
        top: clientCoordinates[1],
        left: clientCoordinates[0]
    };

    function showDetail() {
        if (selectedConnections.length === 1) {
            const connection = selectedConnections[0];
            if (connection.relationshipIdentifier) {
                diagramApi?.showRelationshipDetailDialog(connection.relationshipIdentifier);
            }
        }
        onClose();
    }

    function deleteSelectedItems() {
        if (eventManager) {
            eventManager.publishEvent<OnDeleteSelectedItemsMenuActivatedEvent>({
                type: EventType.ON_DELETE_SELECTED_ITEMS_MENU_ACTIVATED
            })
        }
        onClose();
    }

    function alignNodesClicked(alignmentType: AlignmentType) {
        diagramEditorApi?.onAlignSelectedNodesClicked(alignmentType);
    }

    function onStylesClick() {
        props.onStylesClick();
        onClose();
    }

    return (
        <ContextMenu open={opened}
                     onClose={onClose}
                     anchorPosition={anchorPosition}>
            <MenuItem label={_transl(DiagramEditorTranslationKey.CONTEXT_MENU_SHOW_DETAIL)}
                      icon={<Description/>}
                      disabled={selectedConnections.length !== 1}
                      onClick={showDetail}/>
            <MenuItem label={_transl(CommonTranslationKey.REMOVE)}
                      icon={<Delete/>}
                      shortcut={"⌫"}
                      onClick={deleteSelectedItems}/>
            <Divider/>
            <AlignNodesMenuItems isAlignDisabled={isAlignDisabled}
                                 alignNodesClicked={(type) => alignNodesClicked(type)}
                                 onClose={() => onClose}/>
            <Divider/>
            <MenuItem label={_transl(DiagramEditorTranslationKey.CONTEXT_MENU_STYLES)} icon={<Brush/>}
                      onClick={onStylesClick}/>
        </ContextMenu>
    );
}
